import { render, staticRenderFns } from "./LicenseRu.vue?vue&type=template&id=d2afbbda"
import script from "./LicenseRu.vue?vue&type=script&lang=js"
export * from "./LicenseRu.vue?vue&type=script&lang=js"
import style0 from "./LicenseRu.vue?vue&type=style&index=0&id=d2afbbda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports